import { Global } from '@emotion/react';

import global from './global';

export default function Style() {
  return <Global styles={global} />;
}
